import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { MaterialProperties, ThicknessOption } from '@steelbuy/ts-shared';
import { RFQRangeInput } from './RFQRangeInput';

const WIDTH_FIELD_NAMES = {
    single: 'width',
    min: 'widthMin',
    max: 'widthMax',
};

interface RFQWidthInputProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
    material: MaterialProperties;
    // eslint-disable-next-line react/no-unused-prop-types
    name: TName;
    control: Control<TFieldValues>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rules?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rulesMin?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rulesMax?: any;
}

export const RFQWidthInput = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
    material,
    control,
    rules,
    rulesMin,
    rulesMax,
    name,
}: RFQWidthInputProps<TFieldValues, TName>) => (
    <RFQRangeInput
        isRange={material.widthOption === ThicknessOption.RANGE}
        fieldNames={WIDTH_FIELD_NAMES}
        name={name}
        control={control}
        rules={rules}
        rulesMin={rulesMin}
        rulesMax={rulesMax}
    />
);
